'use client'

import * as Sentry from '@sentry/react'

function FallbackUI() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="mb-3 font-serif text-3xl font-bold text-on-surface">
        Something went wrong
      </h1>
      <p className="mb-6 max-w-md text-on-surface-variant">
        We're sorry for the inconvenience. Please try refreshing the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-full bg-primary px-6 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-container"
      >
        Refresh Page
      </button>
    </div>
  )
}

export default function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
